<!--AFFICHAGE etat etablissement -->
<template>




 <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
         <v-chip
             class="ma-2"
             :color="couleur"
             text-color="white"
             v-bind="attrs"
             v-on="on"
         >
          <v-avatar left>
            <v-icon> {{ icon }}</v-icon>
          </v-avatar>
           <span v-if="!short">{{prefix}}{{ libelle }}</span>
        </v-chip>
          </template>
     <span>{{ tooltip }}</span>
          </v-tooltip>


</template>


<script>
export default {
  name: "Etat",
  props: { value: {}, icon: {}, short: { default: false }, tooltip : {default :""} , prefix : {default : ""}},
  data() {
    return {
      codemapping: {
        A: "Actif",
        C: "Cessé",
        F: "Fermé",
        O: "Oui",
        N: "Non",
      },
      colormapping: {
        A: "green",
        C: "red",
        F: "red",
        O: "red",
        N: "green",
      },
    };
  },

  computed: {
    libelle: function () {
      return this.codemapping[this.value];
    },
    couleur: function () {
      return this.colormapping[this.value];
    },
  },
};
</script>
